import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface HomepageBannerDetailsResponse {
  id: number;
  title: string;
  banner_image: string;
  redirectedURL: string;
  sequence: number;
  published: boolean;
}

// Edit API call
const fetchHomepageBannerDetails = async (id: string, airport: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/${airport}/homepage-banners/${id}`);
  return response.data[0];
};

const useHomepageBannerDetails = (
  id: string,
  airport: string,
  options?: UseQueryOptions<HomepageBannerDetailsResponse, DefaultError, HomepageBannerDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<HomepageBannerDetailsResponse, DefaultError> => {
  return useQuery<HomepageBannerDetailsResponse, DefaultError, HomepageBannerDetailsResponse, QueryKey>(
    {
      queryKey: ["homepageBannerDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchHomepageBannerDetails(id, airport);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useHomepageBannerDetails };
